import * as React from 'react';
import { useClient } from './hooks';
/**
 * DEPRECATED
 * Fetch an Entry or EntryCollection from contentful.
 */
export function useContentful(id, query) {
    const [data, setData] = React.useState();
    const client = useClient();
    let response;
    async function getData() {
        if (!client) {
            // Looks like this app doesn't use CMS features
            // Or Contentful tokens are not in ENV
            if (process.env.NODE_ENV !== 'production') {
                console.warn('No Contentful client instance found in the Provider context.', 'If you intended to use Contentful, make sure you have a ContentfulProvider React Component.');
            }
            return;
        }
        if (!query) {
            // Don't fetch anything without Contentful ID
            if (!id)
                return;
            // Fetch single document by id
            response = await client.context.getEntry(id);
        }
        else {
            // Convert {field: value} to {"fields.[field]": "value"}
            const formattedQuery = Object.entries(query).reduce((aggregate, [field, value]) => ({
                ...aggregate,
                [`fields.${field}`]: value,
            }), {});
            response = await client.context.getEntries({
                content_type: id,
                ...formattedQuery,
            });
        }
        setData(response);
    }
    React.useEffect(() => {
        getData();
    }, [id]);
    return data;
}
